import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    TopConsumedCustomers : [],
    loading : false,
    error : null,
};

const TopConsumedCustomersSlice = createSlice({
    name:"topConsumedCustomers",
    initialState,
    reducers: {
        TopConsumedCustomersSuccess: (state,action) => {
            state.loading = false;
            state.TopConsumedCustomers = action.payload
        },
        TopConsumedCustomersFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    }
})

export const {
    TopConsumedCustomersFailure,
    TopConsumedCustomersSuccess
} = TopConsumedCustomersSlice.actions

export default TopConsumedCustomersSlice.reducer